import { CatHeading } from '@blocks-react/components/Heading';
import { CustomerAccountWelcomeMessageProps } from '../types';

export const CustomerAccountWelcomeMessage = ({
  children
}: CustomerAccountWelcomeMessageProps) => {
  return <CatHeading variant="title">{children}</CatHeading>;
};
